import type { Edge, Node, NodeProps as ReactFlowNodeProps } from 'reactflow';
import { streamEdgeStyle } from '../lib/streamStyles';

export enum NodeType {
  INPUT = 'input',
  PROCESSING = 'processing',
  OUTPUT = 'output',
}

export type StreamType = 'video' | 'audio';
export type WorkflowNodeKind = NodeType.INPUT | NodeType.PROCESSING | NodeType.OUTPUT;

export interface NodeData {
  label: string;
  params?: Record<string, string>;
  command?: string;
  helpText?: string;
  category?: string;
  presetId?: string;
  streamType?: StreamType;
  operation?: 'filter' | 'option';
  inputCount?: number;
  paramOptions?: Record<string, string[]>;
  paramLabels?: Record<string, string>;
  isAudio?: boolean;
  supportsTimeRange?: boolean;
  customFilter?: boolean;
  onChange?: (nodeId: string, patch: Partial<NodeData>) => void;
  onDelete?: (nodeId: string) => void;
}

export type WorkflowNode = Node<NodeData, WorkflowNodeKind>;
export type WorkflowEdge = Edge<{ streamType?: StreamType }>;
export type WorkflowNodeProps = ReactFlowNodeProps<NodeData>;
export type FFMPEGNodeData = NodeData;
export type NodeProps = WorkflowNodeProps;

export interface WorkflowDocument {
  version: 3;
  nodes: WorkflowNode[];
  edges: WorkflowEdge[];
}

export function createOutputNode(id: string, position: { x: number; y: number }, filename = 'output.mp4'): WorkflowNode {
  return {
    id,
    type: NodeType.OUTPUT,
    deletable: true,
    position,
    data: {
      label: '输出文件',
      params: {
        filename,
        videoCodec: 'libx264',
        audioCodec: 'aac',
        quality: '23',
        audioBitrate: '128k',
        preset: 'medium',
      },
    },
  };
}

export function createInitialWorkflow(): WorkflowDocument {
  const input: WorkflowNode = {
    id: 'input-1',
    type: NodeType.INPUT,
    deletable: true,
    position: { x: 120, y: 208 },
    data: { label: '输入文件', params: { filename: 'input.mp4' } },
  };
  const output = createOutputNode('output-1', { x: 710, y: 208 });

  return {
    version: 3,
    nodes: [input, output],
    edges: [
      { id: 'e-input-video-output', source: input.id, sourceHandle: 'video', target: output.id, targetHandle: 'video', data: { streamType: 'video' }, style: streamEdgeStyle('video') },
      { id: 'e-input-audio-output', source: input.id, sourceHandle: 'audio', target: output.id, targetHandle: 'audio', data: { streamType: 'audio' }, style: streamEdgeStyle('audio') },
    ],
  };
}
